/**
 * Engagement Code Constants
 * 
 * These constants represent the code values from Engagement API lookups.
 * Use these instead of magic strings throughout the application.
 */

// Engagement Type Codes
export const ENGAGEMENT_TYPE = {
  ADVISORY: 'Advisory',
  INTERNAL: 'Internal',
} as const

// Engagement Work Type Codes
export const ENGAGEMENT_REQUEST_TYPE = {
  ORIGINAL: 'Original',
  CHANGE: 'Change',
} as const

// Engagement Closed Reason Codes
export const ENGAGEMENT_CLOSED_REASON = {
  COMPLETE: 'Complete',
  CANCELLED: 'Cancelled',
  ON_HOLD: 'OnHold',
} as const

// Engagement Billing Type Codes
export const ENGAGEMENT_BILLING_TYPE = {
  TIME_BASED: 'TimeBased',
  MILESTONE: 'Milestone',
} as const

// Engagement Status Codes
export const ENGAGEMENT_STATUS = {
  DRAFT: 'Draft',
  ACCOUNTING_DRAFT: 'AccountingDraft',
  PENDING_REVIEW: 'PendingReview',
  ACTIVE: 'Active',
  PENDING_CHANGE: 'PendingChange',
  COMPLETED: 'Completed',
  DELETED: 'Deleted',
  REPLACED: 'Replaced',
} as const

// Milestone Status Codes
export const MILESTONE_STATUS = {
  NOT_STARTED: 'NotStarted',
  IN_PROGRESS: 'InProgress',
  COMPLETED: 'Completed',
  ON_HOLD: 'OnHold',
} as const

// Engagement API Lookup Categories
// These are the category strings used to query Engagement API lookups
export const ENGAGEMENT_LOOKUP_CATEGORIES = {
  STATUS: "engagement.CodeEngagementStatus",
  ENGAGEMENT_TYPE: "engagement.CodeEngagementType",
  REQUEST_TYPE: "engagement.CodeEngagementRequestType",
  CLOSED_REASON: "engagement.CodeEngagementClosedReason",
  BILLING_TYPE: "engagement.CodeEngagementBillingType",
  MILESTONE_STATUS: "engagement.CodeMilestoneStatus",
} as const

// Type definitions for type safety
export type EngagementType = typeof ENGAGEMENT_TYPE[keyof typeof ENGAGEMENT_TYPE]
export type EngagementRequestType = typeof ENGAGEMENT_REQUEST_TYPE[keyof typeof ENGAGEMENT_REQUEST_TYPE]
export type EngagementClosedReason = typeof ENGAGEMENT_CLOSED_REASON[keyof typeof ENGAGEMENT_CLOSED_REASON]
export type EngagementBillingType = typeof ENGAGEMENT_BILLING_TYPE[keyof typeof ENGAGEMENT_BILLING_TYPE]
export type EngagementStatus = typeof ENGAGEMENT_STATUS[keyof typeof ENGAGEMENT_STATUS]
export type MilestoneStatus = typeof MILESTONE_STATUS[keyof typeof MILESTONE_STATUS] 